// src/hooks/useProfile.js  —  ohapotato v2026.10.36
import { useState, useEffect, useCallback } from 'react';

const DEFAULT = {
  displayName:  '',
  bio:          '',
  skillLevel:   'Home Cook',
  dietaryPrefs: [],
  avatarUrl:    '',
  isPremium:    false,
};

export function useProfile(userId) {
  const key = userId ? `ohp-profile-${userId}` : null;

  const [profile, setProfile] = useState(() => {
    if (!key) return DEFAULT;
    try { return { ...DEFAULT, ...JSON.parse(localStorage.getItem(key) || '{}') }; }
    catch { return DEFAULT; }
  });

  useEffect(() => {
    if (!key) { setProfile(DEFAULT); return; }
    try { setProfile({ ...DEFAULT, ...JSON.parse(localStorage.getItem(key) || '{}') }); }
    catch { setProfile(DEFAULT); }
  }, [key]);

  const updateProfile = useCallback((updates) => {
    setProfile(prev => {
      const next = { ...prev, ...updates };
      if (key) localStorage.setItem(key, JSON.stringify(next));
      return next;
    });
  }, [key]);

  return { profile, updateProfile };
}
